import React, { useState, useEffect, useContext } from "react";
import AddUser from "../components/AddUser";
import AuthContext from "../AuthContext";
import User from '../components/Tables/Users';
import { useTheme } from '../ThemeContext'; // Adjust the path as necessary

function Sales() {
  const [showSaleModal, setShowSaleModal] = useState(false);
  const [sales, setAllSalesData] = useState([]);
  const [products, setAllProducts] = useState([]);
  const [stores, setAllStores] = useState([]);
  const [updatePage, setUpdatePage] = useState(true);

  const authContext = useContext(AuthContext);
  const { theme } = useTheme(); // Get the theme from context

  // Modal for Sale Add
  const addUserModalSetting = () => {
    setShowSaleModal(!showSaleModal);
  };

  // Handle Page Update
  const handlePageUpdate = () => {
    setUpdatePage(!updatePage);
  };

  return (
    <div className="col-span-12 lg:col-span-10 flex justify-center w-full"> {/* Full width container */}
      <div className="flex flex-col gap-5 w-full"> {/* Flex column with full width */}
        {showSaleModal && (
          <AddUser
            addUserModalSetting={addUserModalSetting}
            handlePageUpdate={handlePageUpdate}
            authContext={authContext}
          />
        )}
        {/* Table */}
        <div className={`overflow-x-auto rounded-sm border w-full ${theme === 'dark' ? 'bg-gray-700 border-gray-600' : 'bg-white border-gray-200'}`}> {/* Full width table */}
          <div className="flex justify-between pt-5 pb-3 px-3">
            <div className="flex gap-4 justify-center items-center">
              <span className={`font-bold ${theme === 'dark' ? 'text-white' : 'text-black'}`}>Users</span>
            </div>
            <div className="flex gap-4">
              <button
                className="bg-blue-500 hover:bg-blue-700 text-white font-bold p-2 text-xs rounded"
                onClick={addUserModalSetting}
              >
                Add Users
              </button>
            </div>
          </div>
          <User handlePageUpdate={handlePageUpdate} updatePage={updatePage} showSaleModal={showSaleModal}/>
        </div>
      </div>
    </div>
  );
}

export default Sales;
